<div class="mainstepcontent row w100">
  <div class="leftside gap-24 grow-1 col">
    <div class="col gap-16 w100">
      <div class="col gap-16" i18n>
        <h1>Validate Your Idea</h1>
        <div>Different perspectives. Different insights</div>
        <!-- <h1>{{ step?.stepTypeName }}</h1> -->
      </div>
    </div>
    <div class="mentorrow col gap-8 w100 align-start align-center stickey" i18n>
      <div class="row gap-8 space-between w100">
        <h3>Let's have a expert chat with_____</h3>
        <div class="menue">
          <rr-icon name="more-vertical"></rr-icon>
          <div class="submenue">
            <div class="item" (click)="resetChat()">Reset Chat</div>
            <div class="item" (click)="openMentorSelect()">Select Coach</div>
          </div>
        </div>
      </div>
      <div class="row gap-16 agentrow space-between w100 align-center">
        <div class="row gap-8 align-center">
          <img
            [src]="
              currentMentor?.image
                ? currentMentor?.image
                : '/images/agents/default.png'
            "
            alt=""
            class="avatar"
          />
          <h4 class="name strong">{{ currentMentor?.viewName }}</h4>
        </div>
        <rr-icon
          class="pointer"
          name="chevron-down"
          (click)="openMentorSelect()"
        ></rr-icon>
      </div>
    </div>
    <!-- <div class="row gap-8" i18n>
      <div class="link">Help me to find the right mentor</div>
      <div class="link">Details of my chat partner</div>
    </div> -->
    <div class="w100 col chatarea">
      <div class="chatcontent w100 grow-1 gap-8 col">
        <div class="conversationentry w100" *ngFor="let entry of chat">
          @if(entry.type =="agent"){
          <div class="col gap-4 align-start">
            <div class="tiny">{{ currentMentor.name }}</div>
            <div class="agententry entry" markdown>
              {{ entry.text }}
            </div>
          </div>
          } @if(entry.type =="user"){
          <div class="col gap-4 align-end justify-end">
            <div class="tiny">You</div>
            <div class="userentry entry" markdown>
              {{ entry.text }}
            </div>
          </div>
          }
        </div>
      </div>
      <div class="row gap-8 w100 addpinarea space-between">
        <rr-btn
          type="Secondary"
          size="Medium"
          class=""
          i18n
          (click)="runWebSearch()"
          *ngIf="currentMentor?.webSearch === true"
          iconStart="web"
          >Run Web Research</rr-btn
        >
        <rr-btn
          type="Secondary"
          size="Medium"
          i18n
          (click)="summarizePrompt()"
          *ngIf="chat.length > 1"
          >Pin chat results to feedback card</rr-btn
        >
      </div>
      <div
        class="col gap-8 w100 messagebox"
        [ngClass]="messageBoxDisabled === true ? 'disabled' : ''"
      >
        <textarea
          type="text"
          class="w100"
          i18n
          placeholder="Your message..."
          [(ngModel)]="chatInput"
          [disabled]="messageBoxDisabled"
          (keyup.enter)="talkToAgent()"
          id="chat-input"
          #textarea
        ></textarea>

        <div class="row space-between w100 align-center">
          <div class="row">
            <rr-icon
              name="mic"
              color="nutral"
              class="pointer"
              *ngIf="recognitionAllowed === true"
              (click)="messageBoxDisabled ? null : startSpeechRecognition()"
            ></rr-icon>
          </div>
          <rr-btn
            type="Primary"
            size="Small"
            iconStart="send"
            [disabled]="messageBoxDisabled || textarea.value === ''"
            (click)="messageBoxDisabled ? null : talkToAgent()"
            >Send</rr-btn
          >
        </div>
      </div>
    </div>
  </div>
  <div class="rightside col">
    <div class="feedbackcard grow-1">
      <div class="row space-between gap-16 align-center w100">
        <h3>Feedback Card</h3>
        <div class="row gap-8 align-center">
          <rr-btn
            iconStart="miro"
            size="Small"
            i18n
            type="Secondary"
            [disabled]="currentPins.length == 0 ? true : false"
            (click)="currentPins.length == 0 ? null : exportToMiro()"
            >Export</rr-btn
          >
          <rr-btn
            iconStart="add"
            size="Small"
            i18n
            type="Secondary"
            (click)="addOwnPin()"
            >Add</rr-btn
          >
        </div>
      </div>
      <div class="w100 pinarea col gap-8">
        @for( stack of currentPins; track stack.sessionId){
        <div class="sessionlabel row gap-8 tiny strong uppercase">
          SESSION - {{ stack.date }}
        </div>

        @for( pin of stack.pins; track pin){
        <rr-pin
          [pin]="pin"
          *ngIf="pin.agentId == currentMentor?.id"
          (delete)="deletePin(pin)"
          (priorize)="priorozePin(pin)"
          (depriorize)="depriotizePin(pin)"
          (edit)="editPin(pin)"
        ></rr-pin>
        } }
      </div>
    </div>
  </div>
</div>
<rr-spinner *ngIf="loading"></rr-spinner>
